import React, { useEffect } from 'react';
import { annotate, annotationGroup } from 'rough-notation';

const PresPage = () => {
    useEffect(() => {
        const pres = document.querySelector('#presentation');
        let scrolling;
        let effect = false;
        window.addEventListener('scroll', () => {
            scrolling = document.documentElement.scrollTop || window.scrollY || window.pageYOffset || document.body.scrollTop;
            if (scrolling >= pres.offsetTop) {
                if (effect === false) {
                    const e = document.querySelector('#title');
                    const soutien = document.querySelector('#soutien');
                    const success = document.querySelector('#success');
                    const bes = document.querySelector('#BES');
                    const a1 = annotate(e, { type: 'highlight', color: '#CDFB4D' });
                    const a2 = annotate(soutien, { type: 'box', color: '#6606F3' });
                    const a3 = annotate(success, { type: 'underline', color: '#d20909' });
                    const a4 = annotate(bes, { type: 'highlight', color: '#CDFB4D' });
                    const ag = annotationGroup([a1, a2, a3, a4]);
                    ag.show();
                    effect = true;
                }
            }
        });
    }, []);


    const schemaData = {
        "@context": "https://schema.org",
        "@type": "EducationalOccupationalProgram",
        "name": "BES Web Developer",
        "description": "Formation diplômante en Web Développement avec HTML, CSS, JavaScript (React, Vue.js), PHP et Symfony, incluant un stage pratique de 7 à 11 semaines.",
        "alternateName": ["Web Developer", "Webdeveloper", "Webdev"],
        "educationalCredentialAwarded": "Brevet de l'Enseignement Supérieur (BES) en Web Development",
        "timeToComplete": "P2Y",
        "provider": {
            "@type": "EducationalOrganization",
            "name": "EPSE",
            "url": "https://www.epse.be",
            "logo": "https://epse.be/logo512.png",
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "50 rue du village",
                "addressLocality": "Enghien",
                "postalCode": "7850",
                "addressCountry": "BE"
            }
        },
        "occupationalCategory": "15-1250.00 Web and Digital Interface Designers",
        "hasCourse": [
            {
                "@type": "Course",
                "name": "Année 1 – Web et technologies",
                "description": "Cours mélangeant environnement Web, SGBD, création d'applications web, UI/UX, initiation à la programmation et scripts clients/serveurs.",
                "provider": {
                    "@type": "EducationalOrganization",
                    "name": "EPSE",
                    "url": "https://www.epse.be"
                },
                "offers": [
                    {
                        "@type": "Offer",
                        "url": "https://www.epse.be/inscription",
                        "priceCurrency": "EUR",
                        "price": "630.60",
                        "availability": "https://schema.org/InStock",
                        "category": "Standard"
                    },
                    {
                        "@type": "Offer",
                        "url": "https://www.epse.be/inscription",
                        "priceCurrency": "EUR",
                        "price": "259.20",
                        "availability": "https://schema.org/InStock",
                        "category": "Reduced"
                    }
                ],
                "hasCourseInstance": [
                    {
                        "@type": "CourseInstance",
                        "courseMode": "Onsite",
                        "location": {
                            "@type": "Place",
                            "name": "EPSE Enghien",
                            "address": {
                                "@type": "PostalAddress",
                                "streetAddress": "50 rue du village",
                                "addressLocality": "Enghien",
                                "postalCode": "7850",
                                "addressCountry": "BE"
                            }
                        },
                        "courseWorkload": "PT740H",
                        "courseSchedule": {
                            "@type": "Schedule",
                            "repeatCount": 9,
                            "repeatFrequency": "P1W"
                        },
                        "offers": [
                            {
                                "@type": "Offer",
                                "url": "https://www.epse.be/inscription",
                                "priceCurrency": "EUR",
                                "price": "630.60",
                                "availability": "https://schema.org/InStock",
                                "category": "Standard"
                            },
                            {
                                "@type": "Offer",
                                "url": "https://www.epse.be/inscription",
                                "priceCurrency": "EUR",
                                "price": "259.20",
                                "availability": "https://schema.org/InStock",
                                "category": "Reduced"
                            }
                        ]
                    }
                ]
            },
            {
                "@type": "Course",
                "name": "Année 2 – Web avancé et stage",
                "description": "Cours avancés front/back, CMS, projet web dynamique, veille technologique et stage pratique de 7 à 11 semaines.",
                "provider": {
                    "@type": "EducationalOrganization",
                    "name": "EPSE",
                    "url": "https://www.epse.be"
                },
                "offers": [
                    {
                        "@type": "Offer",
                        "url": "https://www.epse.be/inscription",
                        "priceCurrency": "EUR",
                        "price": "315.20",
                        "availability": "https://schema.org/InStock",
                        "category": "Standard"
                    },
                    {
                        "@type": "Offer",
                        "url": "https://www.epse.be/inscription",
                        "priceCurrency": "EUR",
                        "price": "122.40",
                        "availability": "https://schema.org/InStock",
                        "category": "Reduced"
                    }
                ],
                "hasCourseInstance": [
                    {
                        "@type": "CourseInstance",
                        "courseMode": "Onsite",
                        "location": {
                            "@type": "Place",
                            "name": "EPSE Enghien / Entreprise partenaire",
                            "address": {
                                "@type": "PostalAddress",
                                "streetAddress": "50 rue du village",
                                "addressLocality": "Enghien",
                                "postalCode": "7850",
                                "addressCountry": "BE"
                            }
                        },
                        "courseWorkload": "PT720H",
                        "courseSchedule": {
                            "@type": "Schedule",
                            "repeatCount": 9,
                            "repeatFrequency": "P1W"
                        },
                        "offers": [
                            {
                                "@type": "Offer",
                                "url": "https://www.epse.be/inscription",
                                "priceCurrency": "EUR",
                                "price": "315.20",
                                "availability": "https://schema.org/InStock",
                                "category": "Standard"
                            },
                            {
                                "@type": "Offer",
                                "url": "https://www.epse.be/inscription",
                                "priceCurrency": "EUR",
                                "price": "122.40",
                                "availability": "https://schema.org/InStock",
                                "category": "Reduced"
                            }
                        ]
                    }
                ]
            }
        ]
    };


    return (
        <div className='slide' id='presentation'>
            <div className="sep">
                Ton futur dans le web commence ici !
            </div>
            <div className="container-pres wrapper">
                <div className="gauche">
                    <h2 id="title">Le BES Web Developer</h2>
                    <img src="/images/code-epse.png" alt="Formation BES Webdeveloper - EPSE" className='img-pres'/>
                </div>
                <div className="droite">
                    <div className="texte">
                        <p>Deviens un-e web développeur-euse accompli-e avec notre <strong>formation diplômante en Web Développement.</strong> (aussi appelée <strong>Webdeveloper</strong>)</p>
                        <p>Notre programme complet et intensif te plonge au cœur des technologies les plus avancées, incluant <strong>HTML, CSS, JavaScript avec React et Vue.js, PHP, et la création d'API avec Symfony.</strong> Avec notre équipe pédagogique expérimentée et nos petits groupes-classes, tu bénéficies d'un <strong id="soutien">soutien individualisé</strong> pour garantir ta <span id="success">réussite.</span></p>
                        <p>En plus de l'apprentissage en classe, notre programme comprend <strong>un stage en entreprise de 7 à 11 semaines</strong>, t'offrant une expérience pratique précieuse.</p>
                        <p><span>Obtiens ton</span> <strong id="BES">Brevet de l'Enseignement Supérieur (BES)</strong> <strong id="wd">web developer</strong> et sois prêt-e à relever les défis du marché du travail. </p>
                        <a className="button rejoindre" href="https://www.epse.be/inscription" target='_blank'>Inscris-toi dès maintenant</a>
                    </div>
                </div>
            </div>

            {/* Ajout du JSON-LD avec React */}
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
            />
        </div>
    );
}

export default PresPage;
